import { useState } from "react";

const faqs = [
  { q: "予約はどのようにすればいいですか？", a: "このページ下部の予約フォーム、またはLINE公式アカウントからご予約いただけます。ご希望の日時と施術内容をお知らせください。折り返しご連絡いたします。" },
  { q: "初めてでも大丈夫ですか？", a: "もちろんです。初回はカウンセリングの時間を設けており、体の状態やご希望を丁寧にお伺いした上で施術内容をご提案します。不安なことがあればお気軽にご質問ください。" },
  { q: "当日キャンセルはできますか？", a: "前日までのキャンセルは無料です。当日キャンセルは施術料金の50%をキャンセル料としていただく場合がございます。体調不良の場合はご相談ください。" },
  { q: "妊娠中でも施術を受けられますか？", a: "安定期（16週以降）の方は施術可能です。ただし、ご体調や医師の判断によって対応が異なる場合があります。ご予約の際にお知らせください。" },
  { q: "駐車場はありますか？", a: "はい、サロンと提携している駐車場がございます。ご予約の際にお知らせいただければ詳細をご案内いたします。電車でお越しの際はお迎えに上がります。" },
  { q: "支払い方法は何が使えますか？", a: "現金およびPayPayにてお支払いいただけます。" },
];

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section id="faq" className="py-24 bg-[#f2ede3]">
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-[#3a4a28]/50 text-xs tracking-[0.4em] mb-4">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl text-[#2a2a1e]">よくあるご質問</h2>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-white rounded-lg border border-[#e0dbd0] overflow-hidden">
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between px-7 py-5 text-left cursor-pointer hover:bg-[#faf8f2] transition-colors"
              >
                <span className="font-serif text-sm text-[#2a2a1e] tracking-wide pr-4">{faq.q}</span>
                <div className="w-5 h-5 flex items-center justify-center text-[#3a4a28] flex-shrink-0">
                  <i className={`ri-${open === i ? "subtract" : "add"}-line text-lg`} />
                </div>
              </button>
              {open === i && (
                <div className="px-7 pb-5 border-t border-[#e8e4d8]">
                  <p className="text-[#5a5a4a] text-sm leading-loose tracking-wide pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
